import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'antd';
import PropTypes from 'prop-types';//props传参检查库

import './statementModal.css'

const StatementModal = (props) => {

    const [isShow, setIsShow] = useState(true);

    useEffect(() => {
    }, []);

    return (
        <Modal
            visible={isShow}//控制弹框是否显示
            centered//垂直居中
            destroyOnClose={true}//关闭即销毁？
            closable={false}//是否显示右上角的关闭按钮
            maskClosable={false}//点击蒙层是否允许关闭	
            width='850px'//弹框宽度
            footer={false}
        >
            <div className='statementModal'>
                <div className='grayText'>Welcome to the Work-integrated Learning Digital Platform! At THEi, we highly value your privacy and are committed to safeguarding your personal information in accordance with the Vocational Training Council&apos;s (“VTC”) Privacy Policy. We take all reasonable steps to protect the confidentiality, privacy, and security of the personal information we hold.</div>
                <div className='grayText'>Before you begin using our platform, we kindly request that you carefully review and acknowledge our data privacy statement below: </div>
                <text>WIL Digital Platform Data Privacy Statement</text>
                <div className='grayText'><text>1. Purpose of Data Collection: </text>We collect your personal information with the aim of providing you with a seamless and personalized experience on the WIL Digital Platform, specifically during the job placement process. This includes delivering tailored content, enhancing platform functionality, and improving our services.</div>
                <div>
                    <div className='grayText'><text>2. Types of Personal Identifiable Information Collected: </text>The information we collect, but not limited to, includes: </div>
                    <ul className='grayText'>
                        <li>Student ID, Student Name, and Student Email</li>
                        <li>CV Package, consisting of Social Media addresses, Contact phone number, Profile picture, and information contained in files & URLs uploaded by students for job applications</li>
                        <li>Assignments and assessments for WIL Module(s)</li>
                    </ul>
                </div>
                <div>
                    <div className='grayText'><text>3. Data Usage and Protection: </text>We use your personal information solely for the purposes outlined in this data privacy statement. Your data will be securely stored and treated with the utmost confidentiality.</div>
                    <ul className='grayText'>
                        <li>Only the Industry Partner to whom you send your job application will have access to your submitted CV Package.</li>
                        <li>The teacher(s) of your Programme of Study will have access to your CV Package, job applications, related communication, and all assignments in the enrolled WIL module.</li>
                        <li>In any other circumstance, we will never sell or share your personal information with any third party without your explicit consent, unless required by law.</li>
                    </ul>
                </div>
                <div className='grayText'><text>4. Data Retention: </text>Your personal information will be retained for as long as necessary to fulfill the purposes stated in this statement or as required by law. Subsequently, it will be deleted. If you wish to request the deletion or modification of your information, please contact us at: thei-wil-hub@thei.edu.hk</div>
                <div className='buttonBox'>
                    <Button className='confirmButton' onClick={() => props.onClose(true)}>Confirm to proceed</Button>
                </div>
                <div className='smallText grayText'>{'To proceed, please click on the "Confirm" button, indicating your understanding, agreement, and consent to the processing of your personal information as described in the WIL Digital Platform data privacy statement.'}</div>
                <div className='smallText grayText'>{"In the event that you choose not to confirm, you will be unable to leverage the WIL Digital Platform for WIL job placement and the WIL Module assignment and assessment. We recommend approaching your Programme's WIL Module Convener for further guidance and discussion."}</div>
                <div className='flexCenterBox smallText grayText'>WIL Digital Platform</div>
            </div>
        </Modal>
    )
}

StatementModal.propTypes = {
    onClose: PropTypes.func.isRequired,
}
export default StatementModal;